import { Checkbox } from "@base/ui/Checkbox";
import TermsOfService from "@features/membership/ui/TermsOfUse";
import { useTranslation } from "react-i18next";
import type { ApplyFormInstance } from "../model/useApplyForm";

type Props = {
  form: ApplyFormInstance;
};

export const TermsSection = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="text-label2">{t("apply.terms.title")}</p>
      <div className="mt-3 p-3 border border-gray-300 rounded-4 bg-gray-10 text-body3 whitespace-pre-wrap max-h-[300px] overflow-y-auto">
        <TermsOfService />
      </div>
      <form.Field name="agreedToTerms">
        {(field) => (
          <Checkbox
            className="flex items-start gap-2 mt-4"
            checked={field.state.value}
            onCheckedChange={(details) => field.handleChange(!!details.checked)}
          >
            <Checkbox.Control />
            <Checkbox.Label>
              {t("apply.terms.agree")} <span className="text-red-500">{t("apply.terms.required")}</span>
            </Checkbox.Label>
          </Checkbox>
        )}
      </form.Field>
    </div>
  );
};
